import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import Dashboard from '../pages/client/Dashboard';
import ContestDetails from '../pages/client/contests/ContestDetails';
import ContestantList from '../pages/client/contestants/ContestantList';
import TransactionList from '../pages/client/transactions/TransactionList';
import Profile from '../pages/client/Profile';
import { default as WithdrawalList } from '../pages/client/withdrawals/WithdrawalList';
import { useCheckPermissions } from '../middleware/checkPermissions';

const ClientRoutes = () => {
  // Vérifie si l'utilisateur est un client avec les permissions de base
  useCheckPermissions(['view_stats']);

  return (
    <Routes>
      {/* Le préfixe /client est déjà géré par le parent */}
      <Route index element={<Navigate to="/client/dashboard" replace />} />
      <Route path="dashboard" element={<Dashboard />} />
      <Route path="contests/:contestId" element={<ContestDetails />} />
      <Route path="contestants" element={<ContestantList />} />
      <Route path="transactions" element={<TransactionList />} />
      <Route path="withdrawals" element={<WithdrawalList />} />
      <Route path="profile" element={<Profile />} />
      <Route path="*" element={<Navigate to="/client/dashboard" replace />} />
    </Routes>
  );
};

export default ClientRoutes;
